import { FC } from 'react';
import { BlockPage, BlockPageProps } from '../../../../routings/pages/BlockPage/BlockPage';
import { Icons } from '@silverfort/sf-components';
import BlockPageMainImage from '../../assets/accessAnalysisBlockPageImage.png';

const topics: BlockPageProps['rightContent']['topics'] = [
    <span>
        Enforce <span className="font-bold"> least privilege</span> to ensure users have the access they really need.
    </span>,
    <span>
        Identify and remove dormant, excessive, or redundant access to
        <span className="font-bold"> reduce risk at scale.</span>
    </span>,
    'Reduce guesswork by transforming access reviews into data-driven decisions.'
];

export const AccessAnalysisBlockPage: FC = () => {
    return (
        <BlockPage
            leftContent={{
                image: BlockPageMainImage,
                title: 'Access Intelligence',
                titleIntroText: 'Introducing'
            }}
            rightContent={{
                accessLink: 'https://www.silverfort.com/access-analysis-signup/?utm_source=PQL&utm_content=main',
                description:
                    'Gain deeper visibility into access patterns and optimize permissions to strengthen security, improve compliance, and streamline operations.',
                icon: Icons.Key,
                title: 'Harden Access and Analyze Privilege',
                topics,
            }}
        />
    );
};
